// Libraries
import Vue from "vue";
import { createPinia, PiniaVuePlugin } from "pinia";
import { VueQueryPlugin, QueryClient } from "@tanstack/vue-query";

import App from "./App.vue";
import PrimeVue from "primevue/config";
import PanelMenu from "primevue/panelmenu";

import VueToast from "vue-toast-notification";

import "primevue/resources/themes/saga-blue/theme.css"; //theme
import "primevue/resources/primevue.min.css"; //core import 'css'
import "primeicons/primeicons.css";
import "vue-toast-notification/dist/theme-sugar.css";
import "primeflex/primeflex.css";
import "apexcharts/dist/apexcharts.css";

const pinia = createPinia();
let alreadyReloaded = false;
Vue.prototype.$isOffline = false;
Vue.prototype.$frontendOrigin = window.location.origin; //para que no use siempre https://siis.policiadesanjuan.gob.ar/

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/sw.js", { scope: "/" })
    .then((registration) => {
      // registration worked
      // console.log("Registration succeeded.", registration);
      // registration.unregister().then((unregistered) => {
      //   if (unregistered) console.log("unregister successful")
      // });
    })
    .catch((error) => {
      // registration failed
      console.error(`Registration failed with ${error}`);
    });
  navigator.serviceWorker.addEventListener("message", function (event) {
    if (event.data === "sw-desregistrado") {
      setTimeout(() => {
        navigator.serviceWorker
          .register("/sw.js")
          .then(function (registration) {
            console.log("Service Worker registrado nuevamente con éxito:", registration);
          })
          .catch(function (error) {
            console.log("Fallo en el registro del Service Worker:", error);
          });
      }, 1000);
    }
  });

  navigator.serviceWorker.addEventListener("message", (event) => {
    const currentPath = router.currentRoute.fullPath;
    if (event.data && event.data.action === "reloadWindow") {
      if (currentPath.startsWith("/actuaciones/new/")) {
        Vue.prototype.$isOffline = true;
        return;
      }
      Vue.prototype.$isOffline = false;
      document.dispatchEvent(new CustomEvent("sw-offline-detected"));
    }
  });
}

const queryClient = new QueryClient();
Vue.use(VueQueryPlugin, { queryClient });

Vue.use(VueToast);
Vue.use(PiniaVuePlugin);

Vue.use(PrimeVue, {
  ripple: true,
  locale: {
    firstDayOfWeek: 1,
    dayNames: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
    dayNamesShort: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
    dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
    monthNames: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ],
    monthNamesShort: [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Oct",
      "Nov",
      "Dic",
    ],
    today: "Hoy",
    clear: "Borrar",
    weekHeader: "Sm",
  },
});

//Axios
import axios from "axios";
import VueAxios from "vue-axios";

Vue.use(VueAxios, axios);

//Vue Router
import router from "@/router/index";

// App

import import_components from "./import_components";
// import_components(Vue);
import_components.load(Vue);
// console.log(import_components)

// Vue.use(VueResource);
Vue.config.productionTip = false;

import * as offline from "./data/localdb";
Vue.prototype.$offline = offline;

import SiisUtils from "./siis_utils";
Vue.prototype.$rest = SiisUtils(store, Vue, axios);
Vue.prototype.$utils = {
  cloneObj: (obj) => JSON.parse(JSON.stringify(obj)),
};

import noEmojiDirective from "./directives/noEmojis";
Vue.directive("no-emoji", noEmojiDirective);

import store from "./store";

import "./data/localdb";
import "./data/local_idb";

import VueApexCharts from "vue-apexcharts";

Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);

new Vue({
  render: (h) => h(App),
  store,
  router,
  pinia,
}).$mount("#app");

Vue.use(PrimeVue);
Vue.component("PanelMenu", PanelMenu);
